import axiosApiInstance from '@/api/shared/axios-instance';
import EquiposPageAlineacion from '@/components/equipos/equipos-page-alineacion';
import Seo from '@/components/shared/custom/seo-component';
import { IsrRevalidateTime } from '@/constants/cache-state-constants';
import { LEAGUES } from '@/constants/leagues';
import { Pages, Rutas } from '@/constants/rutas';
import { currentSeason } from '@/constants/site';
import { obtenerEquipoPorIdOrSlug } from '@/data/equipos';
import URL_FACTORY from '@/helpers/url-helper';

const AlineacionesProbablesTeamsPage = ({ equipo, initialData, fixtures }) => {
    const title = `${equipo.name}: Alineaciones probables de La Liga Fantasy`;
    const description = `${equipo.name}: Once probable, lesionados, sancionados, estadísticas, dudas, convocados, suplentes, alternativas al once, apercibidos y recomendaciones fantasy.`;
    const url = `${process.env.NEXT_PUBLIC_URL_FRONT}${Rutas.EQUIPO}/${equipo.slug}`;
    const image = `${process.env.NEXT_PUBLIC_IMAGES}/2024/alineaciones-probables/${equipo.id}.jpg`;

    return (
        <section className="team-page-section">
            <Seo pageId={Pages.EQUIPO} url={url} description={description} image={image} title={title} />
            {equipo && initialData && (
                <EquiposPageAlineacion
                    id={equipo.id}
                    name={equipo.name}
                    initialData={initialData}
                    initialFixtures={fixtures} // Pasamos los fixtures al componente
                    index={0}
                />
            )}
        </section>
    );
};

export default AlineacionesProbablesTeamsPage;

export async function getStaticPaths() {
    return {
        paths: [], // No predefinimos rutas, lo haremos dinámico
        fallback: 'blocking', // ISR generará las páginas la primera vez que se visiten
    };
}

export async function getStaticProps({ params }) {
    const { slug } = params;

    let equipo = obtenerEquipoPorIdOrSlug(-1, slug);

    if (!equipo) {
        return { notFound: true }; // Si el equipo no existe, devolvemos un 404
    }

    try {
        // Definir los dos requests que se harán en paralelo
        const alineacionesRequest = axiosApiInstance.post(URL_FACTORY.GetFullLineups, {
            teamId: equipo.id,
            round: null, // Puedes ajustar la ronda que deseas obtener
            leagueId: LEAGUES.LA_LIGA,
            season: currentSeason,
        });

        const fixturesRequest = axiosApiInstance.post(URL_FACTORY.POST_URL_TeamCalendar, {
            id: equipo.id,
            season: currentSeason, // Ajusta según lo que quieras pasar
            secondarySeason: null, // Ajusta según tu lógica o configuración
        });

        // Ejecutar ambos requests en paralelo
        const [alineacionesResponse, fixturesResponse] = await Promise.all([
            alineacionesRequest,
            fixturesRequest,
        ]);

        const initialData = alineacionesResponse.data;
        const fixtures = fixturesResponse.data.fixtures;

        return {
            props: {
                equipo,
                initialData, // Datos iniciales de alineaciones
                fixtures, // Datos del calendario del equipo
            },
            revalidate: IsrRevalidateTime.EQUIPO_PAGE, // ISR: Regenerar la página cada 5 minutos
        };
    } catch (_error) {
        return {
            props: {
                equipo,
                initialData: {}, // Datos iniciales de alineaciones
                fixtures: [], // Datos del calendario del equipo
            },
            revalidate: 5, // ISR: Regenerar la página cada 5 minutos
        };
    }
}
